import { ENV } from '@/lib/config/env';
import { client as assetsClient } from '@inference.engine/assets-api-client/web';

import { configureApiClient } from './configure-client';

if (!ENV.ASSETS_API_BASE_URL) {
  throw new Error('ASSETS_API_BASE_URL environment variable is not set');
}

export const assetsHttp = configureApiClient(assetsClient, ENV.ASSETS_API_BASE_URL);
